<!--
 * @Description: 上传云文档
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-25 13:42:08
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-11-14 09:54:43
-->
<template>
  <div class="cloud-page-com">
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" :class="{ 'cloud-modal': formHeight ? true : false }" title-align="start" width="550px" :mask-closable="false" unmount-on-close :ok-loading="loading">
      <template #title> {{ $t('新增云文档') }} </template>
      <jw-form :model="form" label-align="right" auto-label-width ref="cloudForm" @submit="handleSubmit" class="select-item">
        <jw-form-item :label="$t('云文档链接')" field="documentUrls" show-colon :rules="addOptionRules" required :validate-trigger="['blur', 'input', 'change']">
          <div class="cloud-item-list">
            <div class="cloud-item" v-for="(item, index) in form.documentUrls" :key="index">
              <jw-input v-model="item.value" max-length="500" allow-clear :placeholder="$t('请输入云文档链接')" :style="{ width: '300px', marginRight: '10px' }" />
              <icon-minus-circle size="20" class="minus-icon" v-if="form.documentUrls.length > 1" @click="removeCloud(index)" :style="{ 'margin-right': '10px' }" />
              <icon-plus-circle size="20" v-if="index + 1 == form.documentUrls.length" class="plus-icon" @click="addCloud(item)" />
            </div>
          </div>
        </jw-form-item>
        <jw-form-item :label="$t('云文档类型')" field="documentType" show-colon :rules="{ required: true, message: $t('请选择云文档类型') }" :validate-trigger="['blur', 'input', 'change']">
          <jw-select :trigger-props="{ updateAtScroll: true }" :style="{ width: '300px' }" v-model="form.documentType" :placeholder="$t('请选择云文档类型')" allow-clear allow-search>
            <jw-option v-for="item of typeOptions" :key="item.value" :value="item.value">{{ item.label }}</jw-option>
          </jw-select>
        </jw-form-item>
      </jw-form>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, ref, toRefs, watch, inject, onMounted } from 'vue';
import { opportunityService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import { huaYingOrdId } from '@/utils/const';
import { useUserStore } from '@/store';
export default {
  setup(props, ctx) {
    const { t } = useI18n();
    console.log(props);
    const visible = ref(false);
    const cloudForm = ref(); //表单
    const formHeight = ref(false);
    const { userInfo } = useUserStore();
    const data = reactive({
      form: {
        documentUrls: [{ value: '' }],
        documentType: '' //文档类型
      },
      id: inject('detailParams').id, //id,
      type: inject('detailParams').entity,
      typeOptions: [],
      loading: false
    });

    const open = async () => {
      data.form = {
        documentUrls: [{ value: '' }],
        documentType: '' //文档类型
      };
      formHeight.value = false;
      await getDocumentTypeList();
      visible.value = true;
    };
    const handleOk = () => {
      cloudForm.value?.handleSubmit();
    };
    const handleCancel = () => {
      formHeight.value = false;
      visible.value = false;
    };
    //获取文件类型
    const getDocumentTypeList = async () => {
      const params = {
        enumClassName: userInfo?.orgId != huaYingOrdId ? 'DocumentTypeEnum' : 'DocumentTypeHuaYingEnum'
      };
      try {
        const json = await opportunityService.getDocumentTypeList(params);

        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
        }
        data.typeOptions = json?.result;
        console.log(data.typeOptions);
      } catch (e) {
        console.log(e);
      }
    };
    //新增云文档
    const addCloudDocument = async () => {
      data.loading = true;
      const documentUrls = [];
      data.form.documentUrls?.map((item) => {
        documentUrls.push(item.value);
      });
      const params = {
        businessId: data.id,
        type: data.type,
        documentType: data.form.documentType,
        documentUrls: documentUrls
      };
      try {
        const json = await opportunityService.addCloudDocument(params);
        data.loading = false;
        if (!json.error) {
          console.log(json);
          Message.success(t('新增成功'));
          handleCancel();
          ctx.emit('cb');
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        console.log(e);
        data.loading = false;
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    //表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        cloudForm.value.setFields(errorArray);
        return;
      }
      const documentUrls = [];
      data.form.documentUrls?.map((item) => {
        documentUrls.push(item.value);
      });
      const lens = Array.from(new Set(documentUrls)).length; //去重
      if (lens < documentUrls.length) {
        //有重复的数据
        cloudForm.value.setFields({ documentUrls: { status: 'error', message: t('文件已存在，请修改') } });
        return;
      }
      addCloudDocument();
    };
    //新增云文档
    const addCloud = () => {
      if (data.form.documentUrls.length >= 10) {
        Message.error(t('tips.limitNumber'));
        return;
      }
      data.form.documentUrls.push({ value: '' });
    };
    watch(
      () => data.form.documentUrls,
      (v) => {
        console.log(v);
        if (v.length >= 8) {
          formHeight.value = true;
        }
      },
      {
        deep: true
      }
    );
    //删除云文档
    const removeCloud = (index) => {
      data.form.documentUrls.map((list, k) => {
        if (k == index) {
          data.form.documentUrls.splice(k, 1);
        }
      });
    };
    //非空判断
    const addOptionRules = [
      {
        validator: (value, cb) => {
          const values = data.form.documentUrls?.find((el) => el.value.replace(/\s+/g, '') === '');
          let tips = '';
          if (values) {
            tips = t('请输入云文档链接');
            return cb(tips);
          }
          return;
        }
      }
    ];
    onMounted(() => {
      // getDocumentTypeList();
    });
    return {
      visible,
      cloudForm,
      formHeight,
      addOptionRules,
      open,
      handleOk,
      handleCancel,
      handleSubmit,
      addCloud,
      removeCloud,
      getDocumentTypeList,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './upload-cloud-document.less';
</style>
<style>
.cloud-modal .arco-modal-body {
  height: 400px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
